import { captureException } from '@sentry/vue';

/**
 * Report a failure the member is not shown, because the flow carries on without what failed.
 *
 * The browser console is not collected, so a failure that is caught and recovered from reaches
 * Sentry through here, with what was being done when it happened. The console keeps a copy for
 * whoever is running the app locally, where Sentry is not configured.
 */
export function reportFailure(during: string, error: unknown): void {
    captureException(error, { extra: { during } });
    console.error(`${during} failed`, error);
}
